import { call, put, takeLatest } from "redux-saga/effects";
import { client } from "@/core/apollo-client";
import { GET_POINTS, GET_POINT } from "./mutations";
import {
  setPoints,
  fetchPointStart,
  fetchPointSuccess,
  fetchPointFailure,
  fetchPoint,
} from "./reducer";
import { PayloadAction } from "@reduxjs/toolkit";
import { setAccountId } from "@/core/user/reducer";
import { Point } from "@/types";

function* fetchPointsSaga(
  action: PayloadAction<string>
): Generator<any, void, any> {
  const accountId = action.payload;
  if (!accountId) return;
  try {
    const response = yield call([client, client.query], {
      query: GET_POINTS,
      variables: {
        input: {
          filter: {
            brandsId: [],
            citiesId: [],
            isActive: true,
          },
        },
      },
    });
    yield put(setPoints(response.data.points));
  } catch (error) {
    console.error(error);
  }
}

function* fetchPointSaga(
  action: PayloadAction<{ id: string; brandId: string }>
): Generator<any, void, any> {
  try {
    yield put(fetchPointStart());

    const response = yield call([client, client.query], {
      query: GET_POINT,
      variables: {
        input: {
          id: action.payload.id,
          brandId: action.payload.brandId,
        },
      },
    });

    if (response.data.point) {
      yield put(fetchPointSuccess(response.data.point));
    } else {
      yield put(fetchPointFailure("Point not found"));
    }
  } catch (error) {
    console.error("Error fetching point:", error);
    yield put(fetchPointFailure(error.message || "Failed to fetch point"));
  }
}

export function* pointSaga() {
  yield takeLatest(setAccountId.type, fetchPointsSaga);
  yield takeLatest(fetchPoint.type, fetchPointSaga);
}
